import { EventEmitter } from 'events';
/**
 * Asynchronous event emitter that adds
 * the function ```emitAsync()```.
 */
export class AsyncEventEmitter extends EventEmitter {
  emitAsync(type, ...args) {
    return new Promise((resolve, reject) => {
      const handlers = this.listeners(type); // eslint-disable-line
      if (handlers.length === 0) {
        return resolve(false);
      }
      const promises = [];
      handlers.forEach(handler => {
        promises.push(handler(...args));
      });
      Promise.all(promises).then(() => {
        resolve(true);
      }).catch(reject);
    });
  }
}